/**
 * Slovník češtiny (fáze 14) – zdroj pravdy pro klíče. `en.ts` musí mít stejné klíče (test).
 * Plurály: `jedna|dvě až čtyři|ostatní` oddělené svislítkem, `{n}` se doplní.
 */
export const cs = {
  'nav.home': 'Přehled',
  'nav.documents': 'Doklady',
  'nav.new': 'Nový doklad',
  'nav.payments': 'Platby',
  'nav.stock': 'Sklad',
  'nav.jobs': 'Zakázky',
  'nav.assistant': 'Asistent',
  'nav.calendar': 'Kalendář',
  'nav.tasks': 'Úkoly mozku',
  'nav.ads': 'Reklamy',
  'nav.web': 'Weby',
  'nav.wholesale': 'Velkoobchod',
  'nav.reports': 'Přehledy',
  'nav.contacts': 'Kontakty',
  'nav.accountant': 'Účetní',
  'nav.companies': 'Moje firmy',
  'nav.series': 'Číselné řady',
  'nav.pohoda': 'POHODA',
  'nav.more': 'Více',
  'nav.guides': 'Návody',
  'nav.search': 'Hledat…',
  'nav.notifications': 'Notifikace',
  'nav.logout': 'Odhlásit se',
  'nav.shortcuts': 'Klávesové zkratky',
  'nav.shortcuts.search': 'hledání a akce',
  'nav.shortcuts.new': 'nová faktura',
  'nav.shortcuts.help': 'tahle nápověda',
  'nav.account': 'Účet',
  'nav.admin': 'Administrace',

  'common.save': 'Uložit',
  'common.cancel': 'Zrušit',
  'common.close': 'Zavřít',
  'common.delete': 'Smazat',
  'common.edit': 'Upravit',
  'common.back': 'Zpět',
  'common.open': 'Otevřít',
  'common.loading': 'Načítám…',
  'common.nothing': 'Nic tu není.',
  'common.all': 'Vše',
  'common.language': 'Jazyk',
  'common.yes': 'Ano',
  'common.no': 'Ne',

  'home.newInvoice': 'Nová faktura',
  'home.stock': 'Sklad',
  'home.todo': 'K vyřízení',
  'home.payables': 'Závazky',
  'home.customize': 'Upravit přehled',
  'home.customSelection': 'vlastní výběr',
  'home.resetRole': 'Vrátit výchozí podle role',

  'documents.title': 'Doklady',
  'documents.selectAll': 'Vybrat vše',
  'documents.cancelSelection': 'Zrušit výběr',
  'documents.markSent': 'Označit odesláno',
  'documents.csv': 'CSV',
  'documents.csvSelection': 'CSV výběru',
  'documents.empty': 'Zatím žádný doklad.',

  'doc.issue': 'Vystavit',
  'doc.edit': 'Upravit',
  'doc.deleteDraft': 'Smazat koncept',
  'doc.pdf': 'Stáhnout PDF',
  'doc.preview': 'Náhled',
  'doc.sendEmail': 'Poslat e-mailem',
  'doc.markSent': 'Označit jako odeslané',
  'doc.remind': 'Poslat upomínku',
  'doc.items': 'Položky',
  'doc.payments': 'Platby',
  'doc.emails': 'E-maily',
  'doc.archive': 'Archiv',
  'doc.internalNote': 'Interní poznámka',
  'doc.note': 'Poznámka',
  'doc.language': 'Jazyk dokladu',
  'doc.language.cs': 'česky',
  'doc.language.en': 'anglicky',
  'doc.language.cs-en': 'dvojjazyčně (cs / en)',
  'doc.language.sk': 'slovensky',
  'doc.language.de': 'německy',
  'doc.language.pl': 'polsky',
  'doc.language.auto': 'podle partnera',
  'doc.new': 'Nový doklad',
  'doc.draft': 'Koncept',
  'doc.customer': 'Odběratel',
  'doc.supplier': 'Dodavatel',
  'doc.dates': 'Datum',
  'doc.terms': 'Termíny a úhrada',

  'payments.title': 'Platby',
  'stock.title': 'Sklad',
  'stock.units': 'Kusy podle IMEI',
  'stock.products': 'Zboží',
  'stock.movements': 'Pohyby',
  'stock.receive': 'Naskladnit',
  'stock.addProduct': 'Přidat zboží',
  'stock.stocktake': 'Inventura',
  'stock.scanner': 'Skener',
  'contacts.title': 'Kontakty',
  'contacts.addAres': 'Přidat z ARES',
  'contacts.addManual': 'Přidat ručně',

  'more.title': 'Více',
  'more.account': 'Účet',

  'account.title': 'Účet',
  'account.signedInAs': 'Přihlášen jako',
  'account.changePassword': 'Změna hesla',
  'account.devices': 'Přihlášená zařízení',
  'account.loginHistory': 'Historie přihlášení',
  'account.language': 'Jazyk aplikace',
  'account.language.hint': 'Platí pro tohle zařízení i po přihlášení jinde.',
  'account.app': 'Aplikace',

  'login.title': 'Přihlášení',
  'login.register': 'Nový účet',
  'login.email': 'E-mail',
  'login.password': 'Heslo',
  'login.submit': 'Přihlásit se',
  'login.create': 'Vytvořit účet',
  'login.haveAccount': 'Mám už účet, přihlásit se',
  'login.hint':
    'iSupply Faktury. Jeden účet je vlastník všech fakturačních firem; přidáš je pak v Moje firmy.',
  'login.mfa.title': 'Druhý krok',
  'login.mfa.code': 'Kód z autentikátoru nebo záložní kód',
  'login.mfa.back': 'Zpět na heslo',
  'login.mfa.hint': 'Kód se mění každých 30 s. Bez telefonu použij jeden ze záložních kódů.',

  'notifications.title': 'Notifikace',
  'notifications.markAll': 'Označit vše jako přečtené',
  'notifications.empty': 'Zatím žádné notifikace.',
  'approvals.title': 'Schvalování',
  'approvals.pending': 'Čekající',
  'approvals.history': 'Historie',
  'approvals.approve': 'Schválit',
  'approvals.reject': 'Zamítnout',

  'row.pay': 'Úhrada',
  'row.pdf': 'PDF',
  'row.matchPayment': 'Spárovat platbu',
  'row.overpaid': 'Vyřešit přeplatek',
  'row.split': 'Rozdělit platbu',
  'row.openDocument': 'Otevřít doklad',
  'export.failed': 'Export se nepodařil',
  'comments.title': 'Interní komentáře',
  'comments.edited': 'upraveno',
  'common.loadMore': 'Načíst další',
  'plural.unread': '{n} nepřečtená|{n} nepřečtené|{n} nepřečtených',
  'plural.documents': '{n} doklad|{n} doklady|{n} dokladů',
  'plural.items': '{n} položka|{n} položky|{n} položek',
} as const;

export type I18nKey = keyof typeof cs;
